import { type List, Record, type RecordOf } from 'immutable';

import type { Account, AccountAggregatorProps, AccountProps } from 'app-components/flux/accounts/accountsTypes';

type AccountNodePlainAccountFor<T extends AccountProps> = Omit<T, 'aggregators'> & {
  aggregators?: T['aggregators'] | AccountAggregatorProps[] | null;
};

export type AccountNodePlainAccount = AccountNodePlainAccountFor<AccountProps>;

export type AccountNodeDepth = 0 | 1 | 2 | 3;

export type AccountNodeProps = {
  id: string | null;

  depth: AccountNodeDepth;
  isLeaf: number | boolean;
  displayLabel: string;
  displayThemeBgColor: string | null;
  displayThemeColor: string | null;
  displayOrder: number;
  expandable: boolean;
  svgIconId: string;
  routeTo: string | null;
  balanceType?: string;
  createdAt?: string;

  account: Account | null;
  allAccountIds: null | List<string>;

  children: null | List<AccountNode>;

  balance: number;
  goalsBalance: number;
  availableBalance: number;

  currency: string | null;
  hide: boolean;
};

export type AccountNodePlainProps = Omit<AccountNodeProps, 'account' | 'allAccountIds' | 'children'> & {
  account?: AccountNodePlainAccount | null;
  allAccountIds?: string[] | null;
  children?: AccountNodePlainProps[] | null;
};
export const AccountNode = Record<AccountNodeProps>({
  id: null,

  depth: 0,
  isLeaf: 0,
  displayLabel: '',
  displayOrder: 0,
  displayThemeBgColor: null,
  displayThemeColor: null,
  expandable: true,
  svgIconId: '',
  routeTo: null,

  account: null,
  allAccountIds: null,

  children: null,

  balance: 0,
  goalsBalance: 0,
  availableBalance: 0,

  currency: null,
  hide: false,
});
export type AccountNode = RecordOf<AccountNodeProps>;
